/**
 * @generated SignedSource<<2679520198d98a1281a58e45015e85d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type KPIEditMainQuery$variables = {
  routineId: string;
};
export type KPIEditMainQuery$data = {
  readonly routine: {
    readonly activeSections: ReadonlyArray<{
      readonly assignedTeam: {
        readonly color: string | null;
        readonly icon: TeamIcon | null;
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly title: string | null;
    }>;
    readonly activeVersion: {
      readonly tasks: ReadonlyArray<{
        readonly __typename: string;
        readonly goals?: ReadonlyArray<{
          readonly greaterThan: number | null;
          readonly lessThan: number | null;
          readonly section: {
            readonly id: string;
          };
        }>;
        readonly id: string;
        readonly unit?: NumberTaskUnit;
      }>;
    };
    readonly id: string;
    readonly schedule: {
      readonly rules: ReadonlyArray<{
        readonly byhour: ReadonlyArray<number | null> | null;
        readonly byminute: ReadonlyArray<number | null> | null;
        readonly byweekday: ReadonlyArray<number | null> | null;
        readonly freq: RecurrenceFrequency;
        readonly tasks: ReadonlyArray<{
          readonly taskId: string;
        }>;
      }>;
    } | null;
    readonly team: {
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
    };
    readonly title: string;
  } | null;
};
export type KPIEditMainQuery = {
  response: KPIEditMainQuery$data;
  variables: KPIEditMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "tasks",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskNumberGoals",
          "kind": "LinkedField",
          "name": "goals",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "greaterThan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lessThan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineSection",
              "kind": "LinkedField",
              "name": "section",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TaskNumber",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineSection",
  "kind": "LinkedField",
  "name": "activeSections",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "assignedTeam",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v5/*: any*/),
        (v4/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Schedule",
  "kind": "LinkedField",
  "name": "schedule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecurrenceRule",
      "kind": "LinkedField",
      "name": "rules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "freq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "byhour",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "byminute",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "byweekday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecurrenceRuleTask",
          "kind": "LinkedField",
          "name": "tasks",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditMainQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditMainQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "350891e610f69a36853fa42b53bd013e",
    "id": null,
    "metadata": {},
    "name": "KPIEditMainQuery",
    "operationKind": "query",
    "text": "query KPIEditMainQuery(\n  $routineId: ID!\n) {\n  routine(id: $routineId) {\n    id\n    title\n    team {\n      id\n      icon\n      name\n      color\n    }\n    activeVersion {\n      tasks {\n        id\n        __typename\n        ... on TaskNumber {\n          unit\n          goals {\n            greaterThan\n            lessThan\n            section {\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    activeSections {\n      id\n      assignedTeam {\n        id\n        name\n        icon\n        color\n      }\n      title\n    }\n    schedule {\n      rules {\n        freq\n        byhour\n        byminute\n        byweekday\n        tasks {\n          taskId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "abc0212a1819700a8067bba54217368e";

export default node;
